import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-dark-900 flex flex-col items-center justify-center px-4">
      <div className="text-6xl md:text-8xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple mb-4">
        404
      </div>
      <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">{t('notFound.title')}</h1>
      <p className="text-gray-400 text-sm md:text-base max-w-md text-center mb-8">
        {t('notFound.subtitle')}
      </p>
      <button
        onClick={() => navigate('/')}
        className="px-8 py-3 bg-neon-blue text-dark-900 font-semibold rounded-full hover:bg-neon-cyan transition-all duration-300 whitespace-nowrap cursor-pointer"
      >
        {t('notFound.backHome')}
      </button>
    </div>
  );
}
